import { h, Component } from 'preact';
import { sortObjectByOrder, accessNested, joinClasses } from 'utils/utils';
import { Link } from 'components/core/link/link';
import s from 'components/pages/regionSelector/regionSelector.sss';

export default class RegionSelector extends Component {

	renderList(list) {
		const activeRegion = accessNested(this.props, 'appData.meta.region.slug', '');
		const allRegions = Object.entries(this.props.pageData.regions);

		return (
			<div class={s.list}>
				{list.map(region => {
					const regionSlug = allRegions.find(el => el[1].name === region.name)[0];
					const isActive = activeRegion === regionSlug;
					return <Link class={joinClasses(s.region, isActive && s.isActive)} href={region.url}>{region.name}</Link>;
				})}
			</div>
		);
	}

	render({ pageData, client }) {
		const isMobile = client.deviceSize !== 'desktop';
		const { regions } = pageData;
		const list = sortObjectByOrder(regions);


		let list1 = list.slice(0, Math.round(list.length / 2));
		let list2 = list.slice(Math.round(list.length / 2));
		let list3;

		if (!isMobile) {
			list1 = list.slice(0, 17);
			list2 = list.slice(17, 34);
			list3 = list.slice(34);
		}

		return (
			<div class={s.wrapper}>
				<div class={s.container}>
					{this.renderList(list1)}
					{this.renderList(list2)}
					{list3 && this.renderList(list3)}
				</div>
			</div>
		);
	}
}
